import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/aplicativo-categorias',
  name: 'aplicativo-categorias',
  component: Index,
  children: [
    { path: 'listar', name: 'aplicativo-categorias-listar', component: Listar },
    { path: 'novo', name: 'aplicativo-categorias-novo', component: Novo },
    { path: ':id', name: 'aplicativo-categorias-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'aplicativo-categorias-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/aplicativo-categorias/routes.js